import { all, AllEffect } from 'redux-saga/effects';
import NotificationsReducer from './duck/reducer';
import { watchGetNotifications } from './duck/saga';

function* NotificationsSaga(): Generator<AllEffect<Generator>> {
  yield all([watchGetNotifications()]);
}

export { NotificationsReducer, NotificationsSaga };
